import React from 'react'
import { signOut } from 'firebase/auth'
import { auth } from '../../'
import { useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'

const Account = (props) => {
  const navigate = useNavigate();

  // ログアウト処理
  const signOutBtn = (e) => {
    console.log('Sign out');
    signOut(auth).then(() => {
        navigate('/signIn');
    }).catch((error) => {
        console.error('Sign out failed:', error);
    });
  }


  return (
    // アカウント管理ページ
    <div className='p-3 mx-auto max-w-5xl pt-6 mb-3'>
        <h1 className='text-3xl text-center mb-8'><i className="bi bi-person me-2"></i>アカウント</h1>

        <div className='max-w-xl mx-auto'>
          <div className='bg-white shadow p-4 rounded-lg mb-6 mx-4'>
              <h2 className='text-2xl mb-3'>アカウント情報</h2>
              <div className='mb-3'>
                  <label className='block text-sm font-medium text-gray-700'>ユーザ名</label>
                  <p className='text-xl ms-2'>{props.userData.username}</p>
              </div>
              <div className='mb-3'>
                  <label className='block text-sm font-medium text-gray-700'>メールアドレス</label>
                  <p className='text-lg ms-2'>{props.userData.email}</p>
              </div>

              <div className='mb-3'>
                  <label className='block text-sm font-medium text-gray-700'>クレジット</label>
                  <p className='text-xl font-bold ms-2 text-purple-600'>{Number(props.userData.coin).toLocaleString()} pt</p>
              </div>

              <div className='my-6'>
                <h3 className='text-purple-800 text-xl mb-3 ms-2'>アカウントメニュー</h3>
                <Link to="/account/setting" className='block p-2 text-lg text-gray-700 hover:bg-gray-50 w-full text-left border-y'><i className='bi bi-gear mx-2'></i>設定</Link>
                <Link to="/account/achievement" className='block p-2 text-lg text-gray-700 hover:bg-gray-50 w-full text-left border-b'><i className='bi bi-trophy mx-2'></i>実績</Link>
                <Link to="/account/addCoin" className='block p-2 text-lg text-gray-700 hover:bg-gray-50 w-full text-left border-b'><i className='bi bi-wallet mx-2'></i>クレジットの管理</Link>
                <button className='p-2 text-lg text-red-700 hover:bg-gray-50 w-full text-left border-b' onClick={() => signOutBtn()}><i className='bi bi-door-open mx-2'></i>サインアウト</button>
              </div>
          </div>

          
        </div>

        
    </div>
  )
}

export default Account